import { Link } from "react-router-dom";
import ShopHeader from "@/components/site/Nav";

export default function PaymentCancel() {
  return (
    <div className="bg-[#faf8f5] min-h-screen">
      <ShopHeader solid />
      <main className="pt-40 pb-32">
        <div className="mx-auto max-w-[720px] px-6 text-center" data-testid="payment-cancel">
          <h1 className="font-display text-4xl md:text-5xl tracking-tight text-[#111111]">
            Paiement annulé
          </h1>
          <p className="mt-6 font-light text-[#111111]/70">
            Aucun montant n'a été débité. Vos articles sont toujours dans votre
            panier.
          </p>
          <div className="mt-10 flex items-center justify-center gap-4">
            <Link
              to="/cart"
              className="bg-[#111111] px-7 py-4 text-sm font-light tracking-wide text-[#faf8f5] hover:opacity-85 transition-opacity duration-500"
            >
              Revenir au panier
            </Link>
            <Link to="/shop" className="link-underline text-sm font-light">
              Boutique
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
